import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTable as ClbTable_ } from '@celebration/design-system/dist/lib/table';
const events = {
    onClbTableSortChange: ClbTable_.events
        .onClbTableSortChange,
};
export const ClbTable = createComponent({
    tagName: ClbTable_.tagName,
    elementClass: ClbTable_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map